import { render } from "./CleanMotherboard.vue?vue&type=template&id=b54ebe42"
import script from "./CleanMotherboard.vue?vue&type=script&lang=js"
export * from "./CleanMotherboard.vue?vue&type=script&lang=js"

import exportComponent from "/data/vstsagent01/user/2766/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/ui/CleanMotherboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b54ebe42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b54ebe42', __exports__)) {
    console.log('reload')
    api.reload('b54ebe42', __exports__)
  }
  
  module.hot.accept("./CleanMotherboard.vue?vue&type=template&id=b54ebe42", () => {
    console.log('re-render')
    api.rerender('b54ebe42', render)
  })

}


export default __exports__